import { pumpTradeModel } from '@models/pump-trade.model';
import dayjs from 'dayjs';
import type { OpenapiClientPump } from 'src/openapi/pump';
import { useEffect, useRef, useState } from 'react';

export const usePumpTradePresent = () => {
  const lastTimeRef = useRef<{
    timestamp: number;
    type?: OpenapiClientPump.GetTradeTopEventsResponse[number]['type'];
    tx_digest: string;
  }>({
    timestamp: Date.now(),
    type: undefined,
    tx_digest: '',
  });
  const [present, setPresent] = useState<OpenapiClientPump.GetTradeTopEventsResponse>([]);
  const [newPresent, setNewPresent] = useState<OpenapiClientPump.GetTradeTopEventsResponse>([]);

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    const loop = async () => {
      const result = await pumpTradeModel.fetchTradePresent();
      setPresent(result);

      timer = setTimeout(() => {
        loop();
      }, 1000 * 3);
    };
    loop();
    return () => {
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    if (present.length > 0) {
      const data = present.filter(
        (item) => dayjs(item.timestamp).valueOf() >= lastTimeRef.current.timestamp,
      );
      const index = data.findIndex(
        (item) =>
          item.tx_digest === lastTimeRef.current.tx_digest &&
          item.type === lastTimeRef.current.type &&
          dayjs(item.timestamp).valueOf() === lastTimeRef.current.timestamp,
      );
      let final = [];
      if (index === -1) {
        final = data;
      } else {
        final = data.slice(0, index);
      }

      if (final.length > 0) {
        setNewPresent(final);

        if (final[0]) {
          lastTimeRef.current = {
            timestamp: dayjs(final[0].timestamp).valueOf(),
            type: final[0].type,
            tx_digest: final[0].tx_digest,
          };
        }
      }

      setPresent([]);
    }
  }, [present]);

  return newPresent;
};
